<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cXVteW/tc-custom/9781480495487.jpg?1733034392726" alt="This image is the cover for the book Orphans of Earth, The Orphans Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orphans of Earth, The Orphans Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>The sole survivors of the human race... and their time is running out.<br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/><br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/> In the wake of Earth’s fall, Peter Alander has just one choice: to use the alien Gifts left behind on his distant colony world to warn other missions of their impending demise, a second wave of alien ships, this time intent on destroying everything in their path. Without the Gifts, humanity would have no hope at all--although no one truly understands them, and it is becoming increasingly certain that the very use of them is what draws the enemy on.<br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/><br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/> Out of the dark comes help from an entirely unexpected quarter. Peter Alander and his fellow survivors are not the only victims of the terrible Starfish. But what if the cost of that help is too high? What if the price is humanity itself?<br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/><br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/> “This book shines” —Cinescape<br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/><br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/> “High adventure in deep space for fans of far-future SF.” —Library Journal<br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/><br style="color: rgb(88, 89, 91); font-family: Verdana, Geneva, sans-serif;"/> Nominated for the Aurealis and Ditmar Awards.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Williams, Shane Dix
      </h2>
      
      <p class="authorDescription body article">Sean Williams writes for children, young adults, and adults. He is the author of forty novels, ninety short stories, and the odd odd poem, and has also written in universes created by other people, such as those of Star Wars and <I>Doctor Who</I>. His work has won awards, debuted at number one on the <I>New York Times</I> bestseller list, and been translated into numerous languages. His latest novel is <I>Twinmaker</I>, the first in a new series that takes his love affair with the matter transmitter to a whole new level (he just received a PhD on the subject, so don&rsquo;t get him started).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44985097